import { useState, useEffect, useCallback } from 'react'
import { manualFetch } from 'src/utils/fetch'
import CharacterCard from './Charactercards'
import { getCharacters } from 'src/api/user'
import { Spin, Pagination } from 'antd'
import './Sectioncharacter.css'

const SectionCharacter = ({ searchTerm }) => {
  const [avatars, setAvatars] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalAvatars, setTotalAvatars] = useState(0)
  const pageSize = 10

  const fetchImage = useCallback(async (url) => {
    const response = await manualFetch(url, {
      headers: { accept: 'image/*' },
    })
    const blob = await response.blob()
    return URL.createObjectURL(blob)
  }, [])

  const fetchData = useCallback(
    async (page, term) => {
      setLoading(true)
      try {
        const data = await getCharacters(page, pageSize, term)

        const initialAvatars = data.data.map((item) => ({
          ...item,
          imageUrl: null,
          thumbnailImageUrl: null,
        }))

        setAvatars(initialAvatars)
        setTotalAvatars(data.total_items)

        data.data.forEach(async (item) => {
          try {
            const [imageUrl, thumbnailImageUrl] = await Promise.all([
              fetchImage(item.image),
              fetchImage(item.thumbnail),
            ])

            setAvatars((prev) =>
              prev.map((av) =>
                av.id === item.id ? { ...av, imageUrl, thumbnailImageUrl } : av
              )
            )
          } catch (e) {
            console.error('Image load failed', e)
          }
        })
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setLoading(false)
      }
    },
    [fetchImage]
  )

  useEffect(() => {
    fetchData(currentPage - 1, searchTerm)
  }, [currentPage, searchTerm, fetchData])

  return (
    <div>
      {loading && avatars.length === 0 ? (
        <div className="spinner-container">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div className="character-container">
            {avatars.map((room) => (
              <CharacterCard
                key={room.id}
                id={room.id}
                img={room.imageUrl}
                thumbImg={room.thumbnailImageUrl}
                name={room.name}
                desc={room.description}
                enabled={room.enabled}
              />
            ))}
          </div>

          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalAvatars}
            onChange={setCurrentPage}
            showSizeChanger={false}
            style={{ marginTop: 10 }}
          />
        </>
      )}
    </div>
  )
}

export default SectionCharacter
